const DefaultGrid = ({children}) => {

    return (
        <div className={"container mx-auto p-2"}>
            <div className={"grid grid-cols-1 md:grid-cols-2 gap-2"}>
                {children}
            </div>
        </div>
    );
}

export default DefaultGrid;